import moment from 'moment';
import cookieAndLocalStorage from "../../helpers/cookieAndLocalStorage";

const PDF_DOWNLOAD = 'pdfDownload/PDF_DOWNLOAD';
const PDF_DOWNLOAD_SUCCESS = 'pdfDownload/PDF_DOWNLOAD_SUCCESS';
const PDF_DOWNLOAD_FAIL = 'pdfDownload/PDF_DOWNLOAD_FAILURE';
const saveAs = require('react-file-download');

const initialState = {};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case PDF_DOWNLOAD:
      return {
        ...state,
        loading: true,
      };

    case PDF_DOWNLOAD_SUCCESS:
      return {
        ...state,
        clear: true,
        loading: false
      };

    case PDF_DOWNLOAD_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error.data
      };
    default:
      return state;
  }
}

export function download(payload) {
  const requestPayload = { data: { data: payload } };

  return {
    types: [PDF_DOWNLOAD, PDF_DOWNLOAD_SUCCESS, PDF_DOWNLOAD_FAIL],
    loading: true,
    promise: client => client.post('/harcirah/pdf/download', requestPayload)
      .then((response) => {
        if (response && response.size > 0) {
          saveAs(response, `${payload.employeeName}-${moment().format('DD/MM/Y')}-Harcırah-Talep-Formu.pdf`);
        }
      })
  };
}

export function downloadDetail(payload) {
  const requestPayload = { data: { data: payload } };
  return {
    types: [PDF_DOWNLOAD, PDF_DOWNLOAD_SUCCESS, PDF_DOWNLOAD_FAIL],
    loading: true,
    promise: client => client.post('/harcirah/pdf/download-detail', requestPayload)
      .then((response) => {
        if (response && response.size > 0) {
          saveAs(response, `${payload.employeeName}-${moment().format('DD/MM/Y')}-Harcırah-Talep-Formu.pdf`);
        }
      })
  };
}


// WEBPACK FOOTER //
// ./src/redux/modules/pdfDownload.js